export const iconFontAwesomeNumbers5 = (
	<i className="fa-solid fa-5"></i>
);
